<div [style.visibility]="(actions.isUploading$ | async) ? 'visible' : 'hidden'">
    <div class="sk-cube-grid">
        <div class="sk-cube sk-cube1"></div>
        <div class="sk-cube sk-cube2"></div>
        <div class="sk-cube sk-cube3"></div>
        <div class="sk-cube sk-cube4"></div>
        <div class="sk-cube sk-cube5"></div>
        <div class="sk-cube sk-cube6"></div>
        <div class="sk-cube sk-cube7"></div>
        <div class="sk-cube sk-cube8"></div>
        <div class="sk-cube sk-cube9"></div>
    </div>
</div>
<a class="uploadButton" (click)="showDetails(true)">
    <span class="fa fa-upload"></span>
    <!-- <div class="status">Status</div> -->
</a>
<a class="hidden" #uploadFilesButton></a>
<a class="hidden" #uploadImagesButton></a>
<a class="hidden" #uploadAllTypesButton></a>

<p-dialog header="Upload Status" [draggable]="false" [visible]="actions.showDialog$ | async" modal="modal" responsive="true" closable="false" *ngIf="actions.showDialog$ | async">

    <uploader-detail [files]='actions.files$ | async'></uploader-detail>

    <p-footer>
        <div class="dialog-btn-container">
            <button type="button" (click)="showDetails(false)" class="btn btn-cancel">Cancel</button>
            <button type="button" (click)="actions.clearAll()" class="btn btn-danger" [disabled]="!(actions.files$ | async)">
                <i class="fa fa-trash">
                    <label>Clear All</label>
                </i>
            </button>
        </div>
    </p-footer>
</p-dialog>